<template>
  <section id="notFound">
    <div class="lost-text">
      <h1>Lost?</h1>
      <h4>Gloub die Site gits nid...</h4>
    </div>
    <router-link to="/">
      <button class="btn-big btn-white">wider zrügg?</button>
    </router-link>
  </section>
</template>

<script>
export default {
  title: "404 Not Found",
};
</script>

<style lang="scss" scoped>
#notFound {
  height: 100vh;
  width: 100vw;
  background-image: url(~@/assets/img/404/404.jpg);
  background-size: cover;
  background-position: center;
  position: absolute;
  z-index: 1000;
  text-align: left;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  padding: 30vh 10vw 30vh 10vw;
  h1,
  h4 {
    color: #f5f4f3;
  }
  h1 {
    font-size: 9vw;
    text-align: left;
    margin: 0;
  }
  h4 {
    font-size: 1.5vw;
    font-weight: 300;
    letter-spacing: 0.05vw;
  }
}
@media only screen and (max-width: 1024px) {
  #notFound {
    padding: 10vh 10vw 20vh 10vw;
    align-items: center;
    justify-content: space-between;
    h1 {
      font-size: 15vw;
    }
    h4 {
      font-size: 7vw;
    }
  }
}
</style>
